import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 px-4 bg-[#8FF650] text-center border-t-8 border-black" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-107">
          <h2 className="text-4xl md:text-5xl font-black text-black mb-6 uppercase tracking-tight leading-tight" data-id="element-108">
            Tu crecimiento personal puede empezar hoy
          </h2>

          <div className="bg-black text-white p-6 rounded-2xl mb-8 inline-block shadow-xl transform -rotate-1" data-id="element-109">
            <p className="text-xl md:text-2xl font-black mb-1" data-id="element-110">
              No necesitás cambiar tu rutina.
            </p>
            <p className="text-xl md:text-2xl font-bold text-[#8FF650]" data-id="element-111">
              Solo empezar a usar mejor el tiempo que ya tenés.
            </p>
          </div>

          <div className="flex justify-center mb-6" data-id="element-112">
            <CTAButton text="👉 Accedé ahora a la Biblioteca de Crecimiento Personal" className="text-lg md:text-xl py-4 !bg-black !text-[#8FF650] hover:!bg-gray-900" onClick={() => window.open('https://siemprecreciendomas.store/cart/42788575314038:1', '_blank')} data-id="element-113" />
          </div>

          <p className="text-xl font-black text-black uppercase tracking-widest" data-id="element-114">
            Y convertí tus tiempos muertos en aprendizaje.
          </p>
        </motion.div>
      </div>
    </section>;
}